import React, { Component } from 'react';
import logo from "../../assets/img/logo-TAD-d.png";

class Preloader extends Component {
    render() { 
        return (
            <div align="center" style={{paddingTop:"35vh", height:"100vh"}}>
                <img src={logo} className="logo-rotate-fast" alt="Instituto_Logo" width="auto" height="60px"/>
                <div>{/* <i className="fa fa-spinner fa-spin"></i>  */}Espera por favor</div>  
            </div>
        );
    }
}
 
export default Preloader;


// WEBPACK FOOTER //
// ./src/views/Preloader/Preloader.jsx